// extracted by mini-css-extract-plugin
export var aiStarIcon = "_js-2";
export var container = "_js-4";
export var dismissButton = "_js-3";
export var hasPaddingBottom = "_js-6";
export var last = "_js-e";
export var scrollbarThumb = "_js-c";
export var scrollbarTrack = "_js-b";
export var selected = "_js-9";
export var spin = "_js-1";
export var spinning = "_js-0";
export var suggestionItem = "_js-d";
export var suggestionsPanel = "_js-5";
export var tonePill = "_js-8";
export var tonesContainer = "_js-7";
export var unselected = "_js-a";